import { EOriginalContractAvailability } from "src/shared/types/agreements.types";
import { INameValue } from "src/shared/types/common.types";
import { ECurrency } from "src/shared/types/currency.types";
import { IPartnerDto } from "src/shared/types/partner.types";
import { IErrors } from "src/shared/types/partner.types";
import { IBaseQueryParams } from "src/shared/types/query";

export interface IGetSummaryReportQuery extends IBaseQueryParams {
  agency?: string;
  partner_id?: string;
  service?: string;
  report_month: string;
  states?: string | string[];
}
export interface IExportSummaryReportQuery extends IBaseQueryParams {
  report_month: string;
  states?: string | string[];
}

export interface IBonusStateItem {
  id: number;
  is_checked: boolean;
}

export interface IUpdateBonusStatesResponseItem {
  id: number;
  updated: boolean;
  reasons: Array<string>;
}

export enum EBonusState {
  CREATED = "CREATED",
  CHECKED = "CHECKED",
  RESERVED_FOR_1C = "RESERVED_FOR_1C",
  ACT_FORMED = "ACT_FORMED",
  ACT_CARRIED_OUT = "ACT_CARRIED_OUT",
  ACT_IS_SENT = "ACT_IS_SENT",
  ACT_IS_RECEIVED = "ACT_IS_RECEIVED",
  ACT_IS_PAID = "ACT_IS_PAID",
}

export const summaryReportStatuses = {
  [EBonusState.CREATED]: "Создан",
  [EBonusState.CHECKED]: "Проверен",
  [EBonusState.RESERVED_FOR_1C]: "В обработке 1С",
  [EBonusState.ACT_FORMED]: "Акт сформирован",
  [EBonusState.ACT_CARRIED_OUT]: "Акт проведен",
  [EBonusState.ACT_IS_SENT]: "Акт отправлен",
  [EBonusState.ACT_IS_RECEIVED]: "Акт получен",
  [EBonusState.ACT_IS_PAID]: "Акт выплачен",
};
export interface ISummaryReportItem {
  id: number;
  partner: IPartnerDto;
  state: EBonusState;
  partner_contract_number: string;
  tax_system: string;
  active_accounts_quantity: number;
  total_spend: string;
  bonus_sum_by_spend: string;
  previous_period_accumulation: string;
  one_time_reward: number;
  bonus_to_pay: string;
  note: string;
  errors: IErrors;
  partner_email: string | null;
  has_tax_certificate: number;
  contract_original_availability: INameValue<EOriginalContractAvailability>;
  extra_agreement_has_original: boolean;
  complex_contract_currency: ECurrency;
  act_url: string | null;
}

export interface IPostBonusDTO {
  id: number | string;
  active_accounts_quantity: number | string;
  one_time_reward: number | string;
  fixedCacheKey?: string;
}

export enum FormingActsZipStatus {
  IN_PROCESS = "in_process",
  DONE = "done",
  NOT_EXISTS = "not_exists",
  PENDING = "pending",
}

export interface IFormedActsZipDTO {
  path: string;
  acts_in_progress_count: string;
  status: FormingActsZipStatus;
}
